const APIs = {
  REFUNDS_LIST: 'admin/refunds',
}

export default APIs
